import MapBox from '../Map';
import ControlBox from '../ControlBox';
import StoreList from '../StoreList';
import { useGlobal } from '@/utils/useGlobal';

export default function RetailStorePanel({ visible, typeCode }: { visible: boolean, typeCode?: string }) {
    const { useState } = useGlobal();
    const [zoom, setZoom] = useState(12);
    const [showLogoCard, setShowLogoCard] = useState({ show: false, data: {} });
    const [storeLists, setStoreLists] = useState([]);
    const [center, setCenter] = useState();

    const onRecordClick = (store: any) => {
        setShowLogoCard({ show: true, data: store });
        setCenter({ lat: Number(store.latitude), lng: Number(store.longitude) });
        setZoom(14);
    };

    return (
        <div className={`retailStoreBox ${visible ? 'active' : ''}`}>
            <ControlBox
                onBackStore={(value: any) => setStoreLists(value)}
                onBackCenter={(value: any) => setCenter(value)}
                onBackLogoCard={(obj: any) => setShowLogoCard(obj)}
                typeCode={typeCode}
            />
            <div className="resultBox">
                <StoreList storeLists={storeLists} onRecordClick={onRecordClick} />
                <MapBox storeLists={storeLists} center={center} zoom={zoom} showLogoCard={showLogoCard} />
            </div>
        </div>
    );
}
